import type { Bid, UserBidsResponse } from '@/types/bid'
import { httpClient } from '@/utils/request'

enum Api {
  Bids = '/bids',
  MyBids = '/users/me/bids',
}

/**
 * Update a bid
 * RESTful: PUT /bids/{id}
 */
export function updateBid(id: string | number, data: Partial<Bid>) {
  return httpClient.put<Bid>(`${Api.Bids}/${id}`, data)
}

/**
 * Withdraw/Delete a bid
 * RESTful: DELETE /bids/{id}
 */
export function deleteBid(id: string | number) {
  return httpClient.delete<void>(`${Api.Bids}/${id}`)
}

/**
 * 获取我的投标记录
 * RESTful: GET /users/me/bids
 * 支持分页 + 状态筛选 (pending/selected/rejected)
 * 对齐后端 user_bids_router（bids.py L93-141）
 */
export function getMyBids(params?: {
  status?: string
  page?: number
  page_size?: number
}) {
  return httpClient.get<UserBidsResponse>(Api.MyBids, { params })
}
